/* =====================================================================
   Buscador de Carreras PAES 2026 — EurekaPAES · v3
   - REG_CODIGO (región de la sede) como región real
   - Electiva alternativa Ciencias↔Historia (MAX, no SUMA)
   - Inputs clamp 0-1000, live result, what-if mini-simulación
   - Mensajes contextuales estilo EurekaPAES
   ===================================================================== */
(function () {
  'use strict';

  /* ============================================================
     CONSTANTES
     ============================================================ */
  var L = {
    pondLabel: 'Puntaje de corte ponderado',
    clecLabel: 'Referencia CLEC + M1',
    sinPuntaje: 'Sin información',
    sinResultadosT: 'No encontramos carreras con esos filtros',
    sinResultadosP: 'Prueba buscando otra carrera, universidad o cambia el rango de puntaje.',
    yaTodas: 'Ya estás viendo todas las carreras que coinciden con tu búsqueda.',
    ayudaPuntaje: 'Ingresa tus puntajes estimados entre 0 y 1000.'
  };

  var PRUEBAS = [
    { key: 'nem',                 label: 'NEM',                     corto: 'NEM',     icon: '📝' },
    { key: 'ranking',             label: 'Ranking',                 corto: 'Ranking', icon: '📈' },
    { key: 'competencia_lectora', label: 'Competencia Lectora',     corto: 'CLEC',    icon: '📖' },
    { key: 'matematica_m1',       label: 'Matemática M1',           corto: 'M1',      icon: '➕' },
    { key: 'matematica_m2',       label: 'Matemática M2',           corto: 'M2',      icon: '∫' },
    { key: 'ciencias',            label: 'Ciencias',                corto: 'Ciencias',icon: '🔬' },
    { key: 'historia',            label: 'Historia y CC. Sociales', corto: 'Historia',icon: '📜' }
  ];

  var RANGOS_PUNTAJE = [
    { id: 'todos',   label: 'Todos los puntajes', check: function () { return true; } },
    { id: '900+',    label: '900 o más',          check: function (p) { return p != null && p >= 900; } },
    { id: '800-899', label: '800 a 899',          check: function (p) { return p != null && p >= 800 && p < 900; } },
    { id: '700-799', label: '700 a 799',          check: function (p) { return p != null && p >= 700 && p < 800; } },
    { id: '600-699', label: '600 a 699',          check: function (p) { return p != null && p >= 600 && p < 700; } },
    { id: '<600',    label: 'Menos de 600',       check: function (p) { return p != null && p < 600; } },
    { id: 'sin',     label: 'Sin información',    check: function (p) { return p == null; } }
  ];

  var TIPOS_PUNTAJE = [
    { id: 'todos',           label: 'Todos los tipos' },
    { id: 'ponderado',       label: 'Con puntaje ponderado' },
    { id: 'clec_m1',         label: 'Solo referencia CLEC + M1' },
    { id: 'sin_informacion', label: 'Sin información' }
  ];

  var ORDEN = {
    'pp-desc': function (a, b) { return _sortNum(a.puntaje_principal, b.puntaje_principal, -1) || a.carrera.localeCompare(b.carrera, 'es'); },
    'pp-asc':  function (a, b) { return _sortNum(a.puntaje_principal, b.puntaje_principal, 1)  || a.carrera.localeCompare(b.carrera, 'es'); },
    'car-az':  function (a, b) { return a.carrera.localeCompare(b.carrera, 'es'); },
    'car-za':  function (a, b) { return b.carrera.localeCompare(a.carrera, 'es'); },
    'uni-az':  function (a, b) { var c = a.universidad.localeCompare(b.universidad, 'es'); return c !== 0 ? c : a.carrera.localeCompare(b.carrera, 'es'); }
  };
  function _sortNum(a, b, dir) {
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;
    return dir > 0 ? a - b : b - a;
  }

  var PAGE_SIZE = 24;

  /* ============================================================
     ESTADO
     ============================================================ */
  var state = {
    data: [],
    filtrados: [],
    visibles: PAGE_SIZE,
    filtros: { q: '', universidad: '', region: '', area: '', rango: 'todos', tipo: 'todos' },
    orden: 'pp-desc',
    modalActual: null,
    simInputs: {},   // valores actuales de los inputs del simulador
    simBoost: 0      // boost extra del "what-if" para la prueba clave
  };

  /* ============================================================
     UTILIDADES
     ============================================================ */
  function $(s, r) { return (r || document).querySelector(s); }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        var v = attrs[k];
        if (v == null || v === false) continue;
        if (k === 'class') n.className = v;
        else if (k === 'text') n.textContent = v;
        else if (k === 'html') n.innerHTML = v;
        else if (k.indexOf('on') === 0 && typeof v === 'function') n.addEventListener(k.substring(2), v);
        else n.setAttribute(k, v);
      }
    }
    if (children) {
      if (!Array.isArray(children)) children = [children];
      for (var i = 0; i < children.length; i++) {
        var c = children[i];
        if (c == null || c === false) continue;
        if (typeof c === 'string') n.appendChild(document.createTextNode(c));
        else n.appendChild(c);
      }
    }
    return n;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/`/g, '&#96;');
  }
  function normaliza(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function fmtNum(p) {
    if (p == null) return null;
    return (typeof p === 'number' && p % 1 !== 0) ? p.toFixed(1) : String(p);
  }
  function clamp(v, min, max) {
    if (isNaN(v)) return NaN;
    if (v < min) return min;
    if (v > max) return max;
    return v;
  }
  function competitividad(p) {
    if (p == null)  return { c: 'sin-info', l: 'Sin información' };
    if (p >= 900)   return { c: 'muy-alta', l: 'Muy alta' };
    if (p >= 800)   return { c: 'alta',     l: 'Alta' };
    if (p >= 700)   return { c: 'media',    l: 'Media' };
    if (p >= 600)   return { c: 'moderada', l: 'Moderada' };
    return            { c: 'baja',     l: 'Baja' };
  }
  function etiquetaPrincipal(tipo) {
    if (tipo === 'ponderado') return L.pondLabel;
    if (tipo === 'clec_m1')   return L.clecLabel;
    return L.sinPuntaje;
  }

  /* ============================================================
     CARGA DE DATOS
     ============================================================ */
  function bootData() {
    if (window.EP_PAES_DATA && Array.isArray(window.EP_PAES_DATA) && window.EP_PAES_DATA.length > 0) {
      state.data = window.EP_PAES_DATA;
      return Promise.resolve();
    }
    return fetch(window.EP_PAES_DATA_URL || './carreras_paes_2026.min.json').then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (j) {
      state.data = j;
      /* Exponer los datos globalmente para que los modulos de favoritos,
         estrategia, comparador y extras funcionen tambien cuando los datos
         llegan por fetch (Shopify) y no por data1/2/3.js */
      window.EP_PAES_DATA = j;
    });
  }
  function mostrarErrorCarga(err) {
    var cont = $('#ep-paes-resultados');
    cont.innerHTML = '';
    cont.appendChild(el('div', { class: 'ep-paes-vacio' }, [
      el('div', { class: 'ep-paes-vacio-emoji', text: '⚠️' }),
      el('h3', { text: 'No pudimos cargar los datos' }),
      el('p', { html: 'Para la versión <strong>index.html</strong> necesitas servidor local. Para doble clic usa <strong>index-standalone.html</strong>. Detalle: ' + escapeHtml(err && err.message ? err.message : err) })
    ]));
  }

  /* ============================================================
     POBLAR FILTROS
     ============================================================ */
  function poblarSelect(id, valores, placeholder) {
    var sel = $('#' + id);
    sel.innerHTML = '';
    sel.appendChild(el('option', { value: '', text: placeholder }));
    valores.forEach(function (v) { sel.appendChild(el('option', { value: v, text: v })); });
  }
  function poblarFiltros() {
    var unis = {}, regs = {}, areas = {};
    state.data.forEach(function (c) {
      if (c.universidad) unis[c.universidad] = true;
      if (c.region)      regs[c.region] = true;
      if (c.area)        areas[c.area] = true;
    });
    var sortEs = function (a, b) { return a.localeCompare(b, 'es'); };
    poblarSelect('ep-paes-f-uni',    Object.keys(unis).sort(sortEs),  'Todas las universidades');
    poblarSelect('ep-paes-f-region', Object.keys(regs).sort(sortEs),  'Todas las regiones');
    poblarSelect('ep-paes-f-area',   Object.keys(areas).sort(sortEs), 'Todas las áreas');
    var selR = $('#ep-paes-f-rango'); selR.innerHTML = '';
    RANGOS_PUNTAJE.forEach(function (r) { selR.appendChild(el('option', { value: r.id, text: r.label })); });
    var selT = $('#ep-paes-f-tipo'); selT.innerHTML = '';
    TIPOS_PUNTAJE.forEach(function (t) { selT.appendChild(el('option', { value: t.id, text: t.label })); });
  }

  /* ============================================================
     FILTRADO Y RENDER
     ============================================================ */
  function aplicarFiltros() {
    var f = state.filtros;
    var q = normaliza(f.q);
    var rangoFn = (RANGOS_PUNTAJE.filter(function (r) { return r.id === f.rango; })[0] || RANGOS_PUNTAJE[0]).check;
    /* Filtro "alcanzo hoy" */
    var alcanzoActivo = window.EpExtras && window.EpExtras.Alcanzo && window.EpExtras.Alcanzo.isActive();
    var puntajesEstud = alcanzoActivo ? window.EpExtras.Alcanzo.getPuntajes() : null;
    state.filtrados = state.data.filter(function (c) {
      if (f.universidad && c.universidad !== f.universidad) return false;
      if (f.region      && c.region      !== f.region)      return false;
      if (f.area        && c.area        !== f.area)        return false;
      if (f.tipo !== 'todos' && c.tipo_puntaje_principal !== f.tipo) return false;
      if (!rangoFn(c.puntaje_principal)) return false;
      if (alcanzoActivo && !window.EpExtras.Alcanzo.alcanza(c, puntajesEstud)) return false;
      if (q) {
        var blob = normaliza((c.carrera || '') + ' ' + (c.universidad || '') + ' ' + (c.sede || '') + ' ' + (c.region || '') + ' ' + (c.area || '') + ' ' + (c.codigo_demre || ''));
        if (blob.indexOf(q) === -1) return false;
      }
      return true;
    });
    state.filtrados.sort(ORDEN[state.orden] || ORDEN['pp-desc']);
    state.visibles = PAGE_SIZE;
  }
  function render() { aplicarFiltros(); renderContador(); renderTarjetas(); }
  function renderContador() {
    var total = state.data.length, n = state.filtrados.length;
    var mostrando = Math.min(state.visibles, n);
    var txt;
    if (n === 0) txt = '0 carreras encontradas (de ' + total.toLocaleString('es-CL') + ')';
    else if (n === total) txt = 'Mostrando <strong>' + mostrando.toLocaleString('es-CL') + '</strong> de <strong>' + n.toLocaleString('es-CL') + '</strong> carreras';
    else txt = 'Mostrando <strong>' + mostrando.toLocaleString('es-CL') + '</strong> de <strong>' + n.toLocaleString('es-CL') + '</strong> carreras filtradas (' + total.toLocaleString('es-CL') + ' totales)';
    $('#ep-paes-contador').innerHTML = txt;
  }
  function renderTarjetas() {
    var cont = $('#ep-paes-resultados');
    cont.innerHTML = '';
    /* Sugerencias inteligentes según búsqueda */
    if (state.filtros.q && state.filtros.q.length >= 3 && window.EpExtras && window.EpExtras.BuscaInt) {
      var sugs = window.EpExtras.BuscaInt.buscarRelacionadas(state.filtros.q);
      if (sugs.length) {
        var sBox = el('div', { class: 'ep-paes-sugerencias' });
        sBox.appendChild(el('div', { class: 'ep-paes-sugerencias-tit', html: '💡 También podrías mirar:' }));
        var sList = el('div', { class: 'ep-paes-sugerencias-list' });
        sugs.forEach(function (s) {
          sList.appendChild(el('button', {
            type: 'button', class: 'ep-paes-sugerencia-pill', text: s,
            onclick: function () {
              var inp = $('#ep-paes-q');
              if (inp) {
                inp.value = s;
                state.filtros.q = s;
                $('#ep-paes-buscador').classList.add('has-value');
                render();
                inp.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }
          }));
        });
        sBox.appendChild(sList);
        cont.appendChild(sBox);
      }
    }
    if (state.filtrados.length === 0) {
      cont.appendChild(el('div', { class: 'ep-paes-vacio' }, [
        el('div', { class: 'ep-paes-vacio-emoji', text: '🔍' }),
        el('h3', { text: L.sinResultadosT }),
        el('p',  { text: L.sinResultadosP })
      ]));
      $('#ep-paes-cargar-mas-box').innerHTML = '';
      return;
    }
    var grid = el('div', { class: 'ep-paes-grid' });
    var hasta = Math.min(state.visibles, state.filtrados.length);
    for (var i = 0; i < hasta; i++) grid.appendChild(crearTarjeta(state.filtrados[i]));
    cont.appendChild(grid);
    renderCargarMas();
  }
  function renderCargarMas() {
    var box = $('#ep-paes-cargar-mas-box');
    box.innerHTML = '';
    if (state.filtrados.length === 0) return;
    if (state.visibles >= state.filtrados.length) { box.appendChild(el('div', { class: 'ep-paes-fin', text: L.yaTodas })); return; }
    var rest = state.filtrados.length - state.visibles;
    var sig = Math.min(PAGE_SIZE, rest);
    box.appendChild(el('button', {
      type: 'button', text: 'Cargar ' + sig + ' carreras más  →',
      onclick: function () { state.visibles += PAGE_SIZE; renderTarjetas(); renderContador(); }
    }));
  }

  /* ============================================================
     TARJETA
     ============================================================ */
  function crearTarjeta(c) {
    var comp = competitividad(c.puntaje_principal);
    var card = el('article', { class: 'ep-paes-card', 'data-codigo': c.codigo_demre || '' });

    /* Estrella de favoritos (esquina superior derecha) */
    if (window.EpFavs && window.EpFavs.estrellaTarjeta) {
      card.appendChild(window.EpFavs.estrellaTarjeta(c));
    }

    var topRow = el('div', { class: 'ep-paes-card-top' });
    if (c.area) topRow.appendChild(el('span', { class: 'ep-paes-card-area', text: c.area }));
    topRow.appendChild(el('span', { class: 'ep-paes-badge-comp ep-paes-badge-' + comp.c, text: comp.l }));
    card.appendChild(topRow);

    card.appendChild(el('h3', { class: 'ep-paes-card-titulo', text: c.carrera }));
    card.appendChild(el('div', { class: 'ep-paes-card-uni', text: c.universidad }));

    /* Chips de desambiguación */
    var chips = [];
    if (c.sede)   chips.push({ icon: '🏫', text: 'Sede ' + c.sede });
    if (c.region) chips.push({ icon: '📍', text: c.region });
    if (c.codigo_demre) chips.push({ icon: '#', text: 'Código ' + c.codigo_demre });
    if (c.vacantes != null) chips.push({ icon: '🎟️', text: c.vacantes + ' vacantes' });
    if (c.pedagogia)   chips.push({ icon: '📚', text: 'Pedagogía', cls: 'tag-info' });
    if (c.exige_mate2) chips.push({ icon: '➕', text: 'Exige M2', cls: 'tag-warn' });
    if (c.electiva_ciencias_historia) chips.push({ icon: '🔀', text: 'Ciencias o Historia (electiva)', cls: 'tag-electiva' });
    /* Badge "Popular" si está en top 50 de vacantes */
    if (window.EpExtras && window.EpExtras.Populares && window.EpExtras.Populares.isPopular(c.codigo_demre)) {
      chips.push({ icon: '🔥', text: 'Popular', cls: 'tag-popular' });
    }
    var chipsBox = el('div', { class: 'ep-paes-card-chips' });
    chips.forEach(function (ch) {
      chipsBox.appendChild(el('span', {
        class: 'ep-paes-chip' + (ch.cls ? ' ep-paes-' + ch.cls : ''),
        html: '<span class="ep-paes-chip-icon">' + ch.icon + '</span>' + escapeHtml(ch.text)
      }));
    });
    card.appendChild(chipsBox);

    /* Puntaje principal */
    var labelP = etiquetaPrincipal(c.tipo_puntaje_principal);
    var puntCls = 'ep-paes-card-puntaje ep-paes-tipo-' + (c.tipo_puntaje_principal || 'sin');
    var ptjeBox;
    if (c.puntaje_principal == null) {
      ptjeBox = el('div', { class: puntCls + ' sin-info' }, [el('div', { class: 'label', text: labelP }), el('div', { class: 'valor', text: L.sinPuntaje })]);
    } else {
      ptjeBox = el('div', { class: puntCls }, [el('div', { class: 'label', text: labelP }), el('div', { class: 'valor', text: fmtNum(c.puntaje_principal) })]);
    }
    card.appendChild(ptjeBox);

    /* Ponderaciones */
    if (c.ponderaciones && Object.keys(c.ponderaciones).length > 0) {
      card.appendChild(el('div', { class: 'ep-paes-card-pond-label', text: 'Ponderaciones' }));
      var pondList = el('div', { class: 'ep-paes-card-pond-chips' });
      var ord = [];
      for (var pk in c.ponderaciones) {
        if (Object.prototype.hasOwnProperty.call(c.ponderaciones, pk)) {
          var lbl = (PRUEBAS.filter(function (p) { return p.key === pk; })[0] || { corto: pk }).corto;
          ord.push({ key: pk, label: lbl, val: c.ponderaciones[pk] });
        }
      }
      ord.sort(function (a, b) { return b.val - a.val; });
      var topVal = ord[0] ? ord[0].val : 0;
      ord.forEach(function (p) {
        var cls = 'ep-paes-pond-chip' + (p.val === topVal ? ' ep-paes-pond-top' : '');
        pondList.appendChild(el('span', { class: cls,
          html: '<span class="pp-lbl">' + escapeHtml(p.label) + '</span><span class="pp-val">' + p.val + '%</span>'
        }));
      });
      card.appendChild(pondList);
    }

    card.appendChild(el('div', { class: 'ep-paes-card-acciones' }, [
      el('button', { type: 'button', class: 'ep-paes-btn-detalle', text: 'Ver detalle  →', onclick: function () { abrirModal(c); } })
    ]));
    return card;
  }

  /* ============================================================
     MODAL
     ============================================================ */
  function abrirModal(c) {
    state.modalActual = c;
    /* Precargar puntajes globales del estudiante (favoritos) si existen.
       Los cambios en el modal son LOCALES, no se escriben a localStorage. */
    var globalPuntajes = {};
    try { globalPuntajes = JSON.parse(localStorage.getItem('ep_paes_puntajes_v1')) || {}; } catch (e) {}
    state.simInputs = {};
    for (var k in globalPuntajes) {
      if (Object.prototype.hasOwnProperty.call(globalPuntajes, k) && globalPuntajes[k] != null) {
        state.simInputs[k] = globalPuntajes[k];
      }
    }
    state.simInputsTouched = false; /* el usuario aún no ha editado en el modal */
    state.simBoost = 0;
    renderModal();
    /* Exponer función para que otros módulos puedan abrir el modal */
    window.EpPaesAbrirModal = abrirModal;
    /* URL deeplink (?carrera=código) */
    if (window.EpExtras && window.EpExtras.Url) window.EpExtras.Url.setParam('carrera', c.codigo_demre);
    /* Registrar en vistas recientes */
    if (window.EpExtras && window.EpExtras.Recientes) window.EpExtras.Recientes.add(c.codigo_demre);
    var ov = $('#ep-paes-modal-overlay');
    ov.classList.add('is-open');
    ov.scrollTo(0, 0);
    document.body.style.overflow = 'hidden';
  }
  function cerrarModal() {
    $('#ep-paes-modal-overlay').classList.remove('is-open');
    state.modalActual = null;
    document.body.style.overflow = '';
    /* Limpiar parámetro ?carrera de la URL */
    if (window.EpExtras && window.EpExtras.Url) window.EpExtras.Url.setParam('carrera', null);
  }

  function renderModal() {
    var c = state.modalActual;
    if (!c) return;
    var comp = competitividad(c.puntaje_principal);

    /* HEADER */
    var header = $('#ep-paes-modal-header');
    header.innerHTML = '';
    header.appendChild(el('button', { type: 'button', class: 'ep-paes-modal-close', 'aria-label': 'Cerrar', text: '✕', onclick: cerrarModal }));
    if (c.area) header.appendChild(el('div', { class: 'ep-paes-modal-area', text: c.area }));
    header.appendChild(el('h2', { class: 'ep-paes-modal-titulo', text: c.carrera, id: 'ep-paes-modal-titulo' }));
    header.appendChild(el('div', { class: 'ep-paes-modal-uni', text: c.universidad }));
    var meta = [];
    if (c.codigo_demre) meta.push('Código DEMRE: ' + c.codigo_demre);
    if (c.sede)         meta.push('🏫 Sede ' + c.sede);
    if (c.region)       meta.push('📍 ' + c.region);
    if (c.vacantes != null) meta.push('🎟️ ' + c.vacantes + ' vacantes');
    if (c.pedagogia)    meta.push('📚 Pedagogía');
    if (c.exige_mate2)  meta.push('Exige M2');
    if (c.pace)         meta.push('PACE');
    header.appendChild(el('div', { class: 'ep-paes-modal-meta' }, meta.map(function (m) { return el('span', { text: m }); })));

    /* Botón favoritos (sincronizado con la estrella de la tarjeta) */
    if (window.EpFavs && window.EpFavs.botonModal) {
      header.appendChild(window.EpFavs.botonModal(c));
    }

    /* BODY */
    var body = $('#ep-paes-modal-body');
    body.innerHTML = '';

    /* Puntaje principal */
    body.appendChild(seccionTitulo('🎯', 'Puntaje principal'));
    var bigCls = 'ep-paes-puntaje-grande ep-paes-tipo-' + (c.tipo_puntaje_principal || 'sin');
    body.appendChild(el('div', { class: bigCls }, [
      el('div', { class: 'lbl', text: etiquetaPrincipal(c.tipo_puntaje_principal) }),
      el('div', { class: 'val', text: c.puntaje_principal != null ? fmtNum(c.puntaje_principal) : L.sinPuntaje }),
      el('div', { class: 'comp', text: 'Competitividad: ' + comp.l })
    ]));

    /* Stats extra */
    var stats = [];
    if (c.vacantes != null)          stats.push(statCard('Vacantes ofrecidas', c.vacantes));
    if (c.num_seleccionados != null) stats.push(statCard('Seleccionados regulares', c.num_seleccionados));
    if (c.completa_vacantes != null) stats.push(statCard('¿Completa vacantes?', c.completa_vacantes ? 'Sí' : 'No'));
    if (stats.length) body.appendChild(el('div', { class: 'ep-paes-stat-row' }, stats));

    /* Ponderaciones */
    body.appendChild(seccionTitulo('⚖️', 'Ponderaciones de esta carrera'));
    var pondTabla = el('div', { class: 'ep-paes-pond-tabla' });
    var pondConValor = [];
    PRUEBAS.forEach(function (p) {
      var v = c.ponderaciones && c.ponderaciones[p.key];
      if (v != null && v > 0) {
        pondConValor.push(p);
        pondTabla.appendChild(el('div', { text: p.label }));
        pondTabla.appendChild(el('div', { class: 'val', text: v + '%' }));
      }
    });
    if (pondConValor.length === 0) {
      pondTabla.appendChild(el('div', { text: 'Sin ponderaciones declaradas en el Excel.' }));
      pondTabla.appendChild(el('div', { class: 'val', text: '—' }));
    }
    body.appendChild(pondTabla);

    /* Bloque informativo electiva (solo si aplica) */
    if (c.electiva_ciencias_historia) {
      body.appendChild(el('div', { class: 'ep-paes-info-electiva' }, [
        el('div', { class: 'ep-paes-info-electiva__icon', text: '🔀' }),
        el('div', null, [
          el('strong', { text: 'Esta carrera acepta Ciencias o Historia como electiva alternativa' }),
          el('p', { text: 'No se suman ambas. El sistema de admisión usa automáticamente la prueba que más te favorece. Por eso, en el simulador puedes ingresar ambas y usaremos la que aporte mayor puntaje.' })
        ])
      ]));
    }

    /* Consejo estratégico */
    if (pondConValor.length > 0) {
      var top = obtenerTop(c.ponderaciones);
      body.appendChild(el('div', { class: 'ep-paes-consejo', html:
        '💡 <strong>Tu prueba clave para esta carrera es ' + escapeHtml(top.label) + ' (' + top.val + '%)</strong>. ' +
        'Cada punto que subas ahí pesa más que en las otras.'
      }));
    }

    /* Requisitos */
    if (c.prom_min_lenmat != null || c.ponderado_minimo != null || c.exige_mate2 != null || c.pedagogia != null || c.pace != null) {
      body.appendChild(seccionTitulo('📋', 'Requisitos de postulación'));
      var reqs = el('div', { class: 'ep-paes-pond-tabla' });
      if (c.prom_min_lenmat != null) { reqs.appendChild(el('div', { text: 'Promedio mínimo CLEC + M1 para postular' })); reqs.appendChild(el('div', { class: 'val', text: c.prom_min_lenmat })); }
      if (c.ponderado_minimo != null) { reqs.appendChild(el('div', { text: 'Puntaje ponderado mínimo para postular' })); reqs.appendChild(el('div', { class: 'val', text: c.ponderado_minimo })); }
      if (c.exige_mate2 === true)  { reqs.appendChild(el('div', { text: 'Exige Matemática M2' })); reqs.appendChild(el('div', { class: 'val', text: 'Sí' })); }
      if (c.pedagogia === true)    { reqs.appendChild(el('div', { text: 'Carrera de Pedagogía' })); reqs.appendChild(el('div', { class: 'val', text: 'Sí' })); }
      if (c.pace === true)         { reqs.appendChild(el('div', { text: 'Programa PACE' })); reqs.appendChild(el('div', { class: 'val', text: 'Sí' })); }
      body.appendChild(reqs);
    }

    /* Simulador */
    body.appendChild(seccionTitulo('🧮', 'Simulador de puntaje ponderado'));
    body.appendChild(renderSimulador(c));

    /* Distancia mínima al sueño */
    if (window.EpEstrategia && window.EpEstrategia.renderDistancia) {
      var dist = window.EpEstrategia.renderDistancia(c);
      if (dist) body.appendChild(dist);
    }

    /* What-if ampliado por prueba */
    if (window.EpEstrategia && window.EpEstrategia.renderWhatIfAmpliado) {
      var wia = window.EpEstrategia.renderWhatIfAmpliado(c);
      if (wia) body.appendChild(wia);
    }

    /* Carreras alternativas/similares */
    if (window.EpExtras && window.EpExtras.Alt) {
      var altBlock = window.EpExtras.Alt.renderSeccion(c);
      if (altBlock) body.appendChild(altBlock);
    }

    /* Banner "Clase gratis" */
    if (window.EpExtras && window.EpExtras.ClaseGratis) {
      body.appendChild(window.EpExtras.ClaseGratis.render(c));
    }

    /* CTA por carrera */
    body.appendChild(el('div', { class: 'ep-paes-cta-mini' }, [
      el('h3', { text: '¿Quieres preparar esta carrera con una estrategia clara?' }),
      el('p',  { text: 'En EurekaPAES puedes estudiar con cápsulas grabadas, guías tipo PAES, ensayos, mini-quiz y solucionarios paso a paso.' }),
      el('a',  { class: 'ep-paes-cta-btn', href: 'https://www.eurekapaes.cl/collections/preu', target: '_blank', rel: 'noopener noreferrer', text: '🚀 Prepararme con EurekaPAES' })
    ]));
  }

  function seccionTitulo(icon, text) {
    return el('h4', { class: 'ep-paes-modal-h4', html: '<span>' + icon + '</span> ' + escapeHtml(text) });
  }
  function statCard(label, valor, modifier) {
    return el('div', { class: 'ep-paes-stat ' + (modifier || '') }, [
      el('div', { class: 'label', text: label }),
      el('div', { class: 'valor', text: String(valor) })
    ]);
  }
  function obtenerTop(pond) {
    var max = -1, key = null;
    for (var k in pond) {
      if (Object.prototype.hasOwnProperty.call(pond, k)) {
        if (pond[k] > max) { max = pond[k]; key = k; }
      }
    }
    var label = (PRUEBAS.filter(function (p) { return p.key === key; })[0] || { label: key }).label;
    return { key: key, label: label, val: max };
  }

  /* ============================================================
     SIMULADOR PONDERADO INTERACTIVO v3
     - Electiva Ciencias/Historia: MAX, no SUMA
     - Clamp 0-1000
     - Live result aunque falten campos
     - What-if mini-simulación
     ============================================================ */
  function renderSimulador(c) {
    if (!c.ponderaciones || Object.keys(c.ponderaciones).length === 0) {
      return el('div', { class: 'ep-paes-disclaimer', text: 'Esta carrera no tiene ponderaciones declaradas.' });
    }
    var topPrueba = obtenerTop(c.ponderaciones);
    var electiva = c.electiva_ciencias_historia;

    var card = el('div', { class: 'ep-paes-sim-card' });
    card.appendChild(el('p', { class: 'ep-paes-sim-intro2', text: L.ayudaPuntaje }));

    /* Aviso sobre puntajes precargados desde globales (favoritos) */
    var globalPuntajes = {};
    try { globalPuntajes = JSON.parse(localStorage.getItem('ep_paes_puntajes_v1')) || {}; } catch (e) {}
    var tieneGlobales = Object.keys(globalPuntajes).filter(function (k) { return globalPuntajes[k] != null; }).length > 0;
    var avisoBox = el('div', { class: 'ep-paes-modal-sim-aviso' });
    function renderAviso() {
      avisoBox.innerHTML = '';
      avisoBox.className = 'ep-paes-modal-sim-aviso';
      if (state.simInputsTouched) {
        avisoBox.classList.add('is-edited');
        avisoBox.appendChild(el('span', { class: 'icon', text: '✏️' }));
        avisoBox.appendChild(el('span', { class: 'body', html: '<strong>Simulación personalizada para esta carrera.</strong> Tus cambios aquí no afectan tus puntajes globales.' }));
        if (tieneGlobales) {
          var btn = el('button', { type: 'button', class: 'restore', text: '↺ Restaurar mis puntajes' });
          btn.addEventListener('click', function () {
            state.simInputs = {};
            for (var k in globalPuntajes) {
              if (Object.prototype.hasOwnProperty.call(globalPuntajes, k) && globalPuntajes[k] != null) {
                state.simInputs[k] = globalPuntajes[k];
              }
            }
            state.simInputsTouched = false;
            /* Re-render del simulador entero */
            renderModal();
          });
          avisoBox.appendChild(btn);
        }
      } else if (tieneGlobales) {
        avisoBox.appendChild(el('span', { class: 'icon', text: '⭐' }));
        avisoBox.appendChild(el('span', { class: 'body', html: '<strong>Usando tus puntajes guardados en favoritos.</strong> Si los modificas aquí, solo afecta esta simulación.' }));
        var btnClear = el('button', { type: 'button', class: 'clear-local', text: 'Limpiar para esta carrera' });
        btnClear.addEventListener('click', function () {
          state.simInputs = {};
          state.simInputsTouched = true;
          renderModal();
        });
        avisoBox.appendChild(btnClear);
      } else {
        avisoBox.classList.add('is-empty');
        avisoBox.appendChild(el('span', { class: 'icon', text: 'ℹ️' }));
        avisoBox.appendChild(el('span', { class: 'body', html: 'Ingresa tus puntajes para simular esta carrera. <em>Si llenas la sección "Mis puntajes" de favoritos, se precargan aquí automáticamente.</em>' }));
      }
    }
    renderAviso();
    card.appendChild(avisoBox);

    /* INPUTS por prueba */
    var grid = el('div', { class: 'ep-paes-sim-grid' });
    var ponderables = [];

    /* Si hay electiva, agrupamos Ciencias+Historia en un solo bloque visual */
    var keysProcessed = {};
    PRUEBAS.forEach(function (p) {
      if (keysProcessed[p.key]) return;
      var pct = c.ponderaciones[p.key];
      if (pct == null || pct === 0) return;

      if (electiva && (p.key === 'ciencias' || p.key === 'historia')) {
        /* Renderizar bloque electiva con ambos inputs */
        var groupBox = el('div', { class: 'ep-paes-sim-electiva' });
        groupBox.appendChild(el('div', { class: 'ep-paes-sim-electiva__head' }, [
          el('span', { class: 'ep-paes-sim-electiva__icon', text: '🔀' }),
          el('span', { class: 'ep-paes-sim-electiva__title', text: 'Prueba electiva: Ciencias o Historia' }),
          el('span', { class: 'ep-paes-sim-input__pond', text: pct + '%' })
        ]));
        groupBox.appendChild(el('div', { class: 'ep-paes-sim-electiva__hint', text: 'Ingresa ambas si las rendiste. Usaremos automáticamente la que más te favorezca.' }));
        var subgrid = el('div', { class: 'ep-paes-sim-electiva__inputs' });
        ['ciencias', 'historia'].forEach(function (ekey) {
          var ep = PRUEBAS.filter(function (x) { return x.key === ekey; })[0];
          subgrid.appendChild(buildInputBox(ep, pct, false, true));
          keysProcessed[ekey] = true;
          ponderables.push({ key: ekey, pct: pct, label: ep.label, esElectiva: true });
        });
        groupBox.appendChild(subgrid);
        grid.appendChild(groupBox);
      } else {
        grid.appendChild(buildInputBox(p, pct, p.key === topPrueba.key, false));
        ponderables.push({ key: p.key, pct: pct, label: p.label, esElectiva: false });
        keysProcessed[p.key] = true;
      }
    });
    card.appendChild(grid);

    /* RESULTADO en vivo */
    var result = el('div', { class: 'ep-paes-sim-result is-active' });
    card.appendChild(result);

    /* WHAT-IF mini-simulación */
    var whatifWrap = el('div', { class: 'ep-paes-whatif' });
    card.appendChild(whatifWrap);

    function calcular() {
      /* Marcar como editado solo la primera vez (evita re-render que pierde foco) */
      if (!state.simInputsTouched) {
        state.simInputsTouched = true;
        renderAviso();
      }
      /* Recopilar valores con clamp 0-1000 */
      var vals = {};
      var entered = 0;
      ponderables.forEach(function (p) {
        var inp = $('#sim-' + p.key);
        if (!inp) return;
        var raw = (inp.value || '').replace(',', '.');
        var v = parseFloat(raw);
        if (isNaN(v)) {
          state.simInputs[p.key] = null;
          updateBar(inp, 0, false);
          return;
        }
        /* CLAMP */
        var clamped = clamp(v, 0, 1000);
        if (clamped !== v) {
          inp.value = clamped;
          v = clamped;
        }
        state.simInputs[p.key] = v;
        vals[p.key] = v;
        updateBar(inp, v, true);
        entered++;
      });

      /* Calcular ponderado */
      var total = 0;
      var aportes = []; // {label, val, ponderado, esElectiva, usado}
      var electivaUsada = null; // 'ciencias' | 'historia' | null
      var electivaDescartada = null;

      if (electiva && (vals.ciencias != null || vals.historia != null)) {
        var pct = c.ponderaciones.ciencias;
        var aC = (vals.ciencias != null) ? vals.ciencias * (pct / 100) : -Infinity;
        var aH = (vals.historia != null) ? vals.historia * (pct / 100) : -Infinity;
        if (aC > aH) {
          electivaUsada = 'ciencias';
          electivaDescartada = (vals.historia != null) ? 'historia' : null;
          total += vals.ciencias * (pct / 100);
        } else {
          electivaUsada = 'historia';
          electivaDescartada = (vals.ciencias != null) ? 'ciencias' : null;
          total += vals.historia * (pct / 100);
        }
      }

      ponderables.forEach(function (p) {
        if (electiva && (p.key === 'ciencias' || p.key === 'historia')) {
          /* ya manejado arriba */
          var usado = (p.key === electivaUsada);
          aportes.push({
            label: p.label, val: vals[p.key], pct: p.pct,
            ponderado: (vals[p.key] != null) ? vals[p.key] * (p.pct / 100) : null,
            esElectiva: true, usado: usado
          });
          /* visual: marcar la usada */
          var box = $('#sim-' + p.key);
          if (box) {
            var parent = box.closest('.ep-paes-sim-input');
            if (parent) parent.classList.toggle('is-electiva-usada', usado && vals[p.key] != null);
          }
          return;
        }
        if (vals[p.key] != null) {
          var ap = vals[p.key] * (p.pct / 100);
          total += ap;
          aportes.push({ label: p.label, val: vals[p.key], pct: p.pct, ponderado: ap, usado: true });
        } else {
          aportes.push({ label: p.label, val: null, pct: p.pct, ponderado: null, usado: false });
        }
      });

      var pond = Math.round(total * 10) / 10;
      var um = c.ponderado_ultimo_matriculado;
      var pm = c.ponderado_minimo;
      var corte = (um != null) ? um : (pm != null ? pm : null);
      var corteLabel = (um != null) ? 'Puntaje de corte ponderado' : 'Ponderado mínimo para postular';

      /* Render del resultado en vivo */
      var html = '';
      var pendientes = ponderables.length - (electiva ? 1 : 0); // electiva cuenta como 1
      var ingresados = entered - (electiva && vals.ciencias != null && vals.historia != null ? 1 : 0);

      html += '<div class="ep-paes-sim-result__head">' +
                '<div class="ep-paes-sim-result__label">Tu puntaje ponderado estimado</div>' +
              '</div>';
      html += '<div class="ep-paes-sim-result__big">' + (entered === 0 ? '—' : pond.toLocaleString('es-CL')) + '</div>';

      /* Faltan campos */
      var faltan = ponderables.filter(function (p) { return vals[p.key] == null; });
      if (electiva) {
        /* la electiva cuenta como 1 sola si tiene al menos uno */
        var faltElect = !(vals.ciencias != null || vals.historia != null);
        var faltanNoElect = faltan.filter(function (p) { return p.key !== 'ciencias' && p.key !== 'historia'; });
        var total_faltan = faltanNoElect.length + (faltElect ? 1 : 0);
        if (total_faltan > 0) {
          html += '<div class="ep-paes-sim-result__pending">Te faltan ' + total_faltan + ' puntaje' + (total_faltan>1?'s':'') + ' para completar la simulación.</div>';
        }
      } else if (faltan.length > 0) {
        html += '<div class="ep-paes-sim-result__pending">Te faltan ' + faltan.length + ' puntaje' + (faltan.length>1?'s':'') + ' para completar la simulación.</div>';
      }

      /* Gauge */
      if (corte != null && entered > 0) {
        var gPct = Math.max(0, Math.min(110, (pond / corte) * 100));
        var markPct = 100; // corte = 100 %
        html += '<div class="ep-paes-sim-result__vs">vs <strong>' + corteLabel + ': ' + fmtNum(corte) + '</strong></div>';
        html += '<div class="ep-paes-sim-gauge">' +
                  '<i style="width:' + gPct.toFixed(0) + '%"></i>' +
                  '<span class="mark" style="left:' + markPct + '%" title="Corte"></span>' +
                '</div>';
      }

      /* Mensaje sobre electiva usada */
      var msgs = [];
      if (electiva && (vals.ciencias != null || vals.historia != null)) {
        var ePctVal = c.ponderaciones.ciencias;
        if (electivaUsada === 'ciencias') {
          var aporta = Math.round(vals.ciencias * (ePctVal / 100) * 10) / 10;
          var txt = 'Electiva usada: <strong>Ciencias</strong>. Aporta <strong>' + aporta + '</strong> puntos.';
          if (electivaDescartada) txt += ' Historia queda descartada porque aporta menos en esta simulación.';
          msgs.push({ tipo: 'info', icon: '🔀', text: txt });
        } else {
          var aporta2 = Math.round(vals.historia * (ePctVal / 100) * 10) / 10;
          var txt2 = 'Electiva usada: <strong>Historia</strong>. Aporta <strong>' + aporta2 + '</strong> puntos.';
          if (electivaDescartada) txt2 += ' Ciencias queda descartada porque aporta menos en esta simulación.';
          msgs.push({ tipo: 'info', icon: '🔀', text: txt2 });
        }
      }

      /* Mensajes contextuales (solo si hay al menos 1 input lleno) */
      if (entered > 0 && corte != null) {
        var dif = Math.round((corte - pond) * 10) / 10;
        if (dif > 100) msgs.push({ tipo: 'danger', icon: '⚠️', text: 'Te faltan <strong>' + dif + ' puntos</strong>. Todavía falta camino, pero ya sabes dónde enfocarte.' });
        else if (dif > 50) msgs.push({ tipo: 'warning', icon: '🎯', text: 'Te faltan <strong>' + dif + ' puntos</strong>. Con foco en lo que más pondera puedes acercarte.' });
        else if (dif > 0) msgs.push({ tipo: 'warning', icon: '💪', text: '¡Estás cerca! Te faltan solo <strong>' + dif + ' puntos</strong>.' });
        else if (dif === 0) msgs.push({ tipo: 'success', icon: '🎉', text: 'Igualas exactamente el corte ponderado.' });
        else msgs.push({ tipo: 'success', icon: '🚀', text: '¡Vas bien! Superas el corte por <strong>' + Math.abs(dif) + ' puntos</strong>.' });
      }

      /* Prueba clave */
      if (entered > 0) {
        msgs.push({ tipo: 'info', icon: '💡', text: 'Tu prueba clave para esta carrera es <strong>' + escapeHtml(topPrueba.label) + ' (' + topPrueba.val + '%)</strong>.' });
      }

      /* Pruebas bajas con alta ponderación */
      var altasYBajas = aportes.filter(function (a) { return a.usado && a.val != null && a.pct >= 20 && a.val < 500; });
      if (altasYBajas.length) {
        msgs.push({ tipo: 'warning', icon: '👀', text: 'Ojo con: <strong>' + altasYBajas.map(function(a){return escapeHtml(a.label);}).join(', ') + '</strong>. Pesa mucho y hoy te está bajando el ponderado.' });
      }

      if (msgs.length) {
        var mhtml = '<div class="ep-paes-sim-msgs">';
        msgs.forEach(function (m) {
          mhtml += '<div class="ep-paes-sim-msg is-' + m.tipo + '">' +
                    '<span class="ep-paes-sim-msg__icon">' + m.icon + '</span><span>' + m.text + '</span></div>';
        });
        mhtml += '</div>';
        html += mhtml;
      }

      result.innerHTML = html;

      /* WHAT-IF: solo si hay valor para la prueba top */
      whatifWrap.innerHTML = '';
      if (entered > 0 && vals[topPrueba.key] != null && (1000 - vals[topPrueba.key]) > 0) {
        var currentTop = vals[topPrueba.key];
        var maxBoost = Math.min(100, 1000 - currentTop);
        var options = [10, 25, 50, 100].filter(function (b) { return b <= maxBoost; });
        if (options.length) {
          var box = el('div', { class: 'ep-paes-whatif__box' });
          box.appendChild(el('h5', { class: 'ep-paes-whatif__title', html: '🚀 ¿Qué pasa si subo mi prueba clave (' + escapeHtml(topPrueba.label) + ')?' }));
          var btns = el('div', { class: 'ep-paes-whatif__btns' });
          options.forEach(function (boost) {
            btns.appendChild(el('button', {
              type: 'button',
              class: 'ep-paes-whatif__btn' + (state.simBoost === boost ? ' is-active' : ''),
              text: '+' + boost + ' pts',
              onclick: function () { state.simBoost = (state.simBoost === boost) ? 0 : boost; calcular(); }
            }));
          });
          box.appendChild(btns);
          if (state.simBoost > 0) {
            var newTop = currentTop + state.simBoost;
            var deltaPond = Math.round(state.simBoost * (topPrueba.val / 100) * 10) / 10;
            var newPond = Math.round((pond + deltaPond) * 10) / 10;
            var msg = '<div class="ep-paes-whatif__result">' +
                      'Si subes <strong>' + escapeHtml(topPrueba.label) + '</strong> de <strong>' + currentTop + '</strong> a <strong>' + newTop + '</strong>, ' +
                      'tu ponderado subiría a <strong>' + newPond + '</strong> (+' + deltaPond + ' puntos).</div>';
            box.appendChild(el('div', { html: msg }));
          } else {
            box.appendChild(el('div', { class: 'ep-paes-whatif__hint', text: 'Toca un botón para ver cuánto subiría tu ponderado.' }));
          }
          whatifWrap.appendChild(box);
        }
      }
    }

    function updateBar(inputEl, v, filled) {
      var parent = inputEl.closest('.ep-paes-sim-input');
      if (!parent) return;
      parent.classList.toggle('is-filled', !!filled);
      var bar = parent.querySelector('.ep-paes-sim-input__bar > i');
      if (bar) bar.style.width = Math.max(0, Math.min(100, v / 10)) + '%';
    }

    grid.addEventListener('input', function (e) {
      if (e.target && e.target.matches('input')) calcular();
    });
    setTimeout(calcular, 0);
    return card;
  }

  function buildInputBox(p, pct, isTop, isElectivaInner) {
    /* Precargar valor desde state.simInputs (puede venir de globales o ser local) */
    var preval = (state.simInputs && state.simInputs[p.key] != null) ? state.simInputs[p.key] : '';
    var input = el('input', {
      type: 'number', min: '0', max: '1000', step: '0.1',
      inputmode: 'decimal', id: 'sim-' + p.key, placeholder: '0 a 1000',
      class: 'ep-paes-sim-input__field',
      value: preval,
      'aria-label': p.label
    });
    var bar = el('i', null);
    var barWrap = el('div', { class: 'ep-paes-sim-input__bar' }, [bar]);
    var head = el('div', { class: 'ep-paes-sim-input__head' }, [
      el('span', { class: 'ep-paes-sim-input__icon', text: p.icon }),
      el('span', { class: 'ep-paes-sim-input__label', text: p.label }),
      (isElectivaInner ? null : el('span', { class: 'ep-paes-sim-input__pond' + (isTop ? ' is-top' : ''), text: pct + '%' }))
    ]);
    var isFilled = (preval !== '' && preval != null);
    return el('div', { class: 'ep-paes-sim-input' + (isTop ? ' is-top' : '') + (isElectivaInner ? ' is-electiva' : '') + (isFilled ? ' is-filled' : '') }, [head, input, barWrap]);
  }

  function bindControles() {
    var inp = $('#ep-paes-q');
    var wrap = $('#ep-paes-buscador');
    inp.addEventListener('input', function () {
      state.filtros.q = inp.value;
      wrap.classList.toggle('has-value', !!inp.value);
      debounceRender();
    });
    $('#ep-paes-buscador .limpiar-input').addEventListener('click', function () {
      inp.value = ''; state.filtros.q = '';
      wrap.classList.remove('has-value'); render(); inp.focus();
    });
    $('#ep-paes-f-uni').addEventListener('change',    function (e) { state.filtros.universidad = e.target.value; render(); });
    $('#ep-paes-f-region').addEventListener('change', function (e) { state.filtros.region      = e.target.value; render(); });
    $('#ep-paes-f-area').addEventListener('change',   function (e) { state.filtros.area        = e.target.value; render(); });
    $('#ep-paes-f-rango').addEventListener('change',  function (e) { state.filtros.rango       = e.target.value; render(); });
    $('#ep-paes-f-tipo').addEventListener('change',   function (e) { state.filtros.tipo        = e.target.value; render(); });
    $('#ep-paes-f-orden').addEventListener('change',  function (e) { state.orden               = e.target.value; render(); });
    /* Filtro "alcanzo hoy" */
    var alcChk = $('#ep-paes-f-alcanzo');
    if (alcChk && window.EpExtras && window.EpExtras.Alcanzo) {
      alcChk.checked = window.EpExtras.Alcanzo.isActive();
      alcChk.addEventListener('change', function (e) {
        if (e.target.checked && !window.EpExtras.Alcanzo.hasPuntajes()) {
          alert('Necesitas ingresar al menos 3 puntajes en "Mis puntajes" para activar este filtro.');
          e.target.checked = false;
          return;
        }
        window.EpExtras.Alcanzo.setActive(e.target.checked);
        render();
      });
    }
    $('#ep-paes-btn-limpiar').addEventListener('click', function () {
      state.filtros = { q: '', universidad: '', region: '', area: '', rango: 'todos', tipo: 'todos' };
      state.orden = 'pp-desc';
      inp.value = ''; wrap.classList.remove('has-value');
      $('#ep-paes-f-uni').value = ''; $('#ep-paes-f-region').value = ''; $('#ep-paes-f-area').value = '';
      $('#ep-paes-f-rango').value = 'todos'; $('#ep-paes-f-tipo').value = 'todos'; $('#ep-paes-f-orden').value = 'pp-desc';
      render();
    });
    var ov = $('#ep-paes-modal-overlay');
    ov.addEventListener('click', function (e) { if (e.target === ov) cerrarModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarModal(); });
  }
  var debounceTimer = null;
  function debounceRender() { clearTimeout(debounceTimer); debounceTimer = setTimeout(render, 130); }

  function init() {
    /* Exponer abrirModal globalmente para que app-favoritos.js pueda llamar al modal */
    window.EpPaesAbrirModal = abrirModal;
    bindControles();
    bootData().then(function () {
      poblarFiltros();
      $('#ep-paes-f-orden').value = 'pp-desc';
      render();
      /* Renderizar panel de favoritas ahora que los datos están disponibles */
      if (window.EpFavs && window.EpFavs.render) window.EpFavs.render();
    }).catch(mostrarErrorCarga);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
